import React, { forwardRef } from 'react';
import { useFocusRing } from '@react-aria/focus';
import { useObjectRef } from '../../hooks/useObjectRef';
import { HiddenInput } from '../checkbox/styled';
import { StyledLabelToggle, Slider } from './styled';
const Toggle = forwardRef(function Toggle(props, externalRef) {
    const { checked, label, disabled = false, className, ...rest } = props;
    const ref = useObjectRef(externalRef);
    const { focusProps } = useFocusRing();
    return (React.createElement(StyledLabelToggle, { className: className, checked: checked, disabled: disabled },
        React.createElement(HiddenInput, { ref: ref, type: "checkbox", checked: checked, disabled: disabled, ...focusProps, ...rest }),
        React.createElement(Slider, { checked: checked, disabled: disabled }),
        label));
});
export default Toggle;
